import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})

export class MainMenuService {

	menus: any;
	Permission: any;
	public unitInfo: any;
	public MenuList: any;
	public MenuListmyMethodSubject = new BehaviorSubject([]);
	public MenuListcurrentTable = this.MenuListmyMethodSubject.asObservable();

	public UserPermission: any;
	public UserPermissionmyMethodSubject = new BehaviorSubject([]);
	public UserPermissioncurrentTable = this.UserPermissionmyMethodSubject.asObservable();


	constructor(@Inject(HttpClient) private http: HttpClient) {
		this.http = http;
		this.Permission = []; 
		this.MenuList = [];
	}

	MenuListSetter(_id) {
		var data = { "UserID": _id };
		const unitInfo = JSON.parse(localStorage.getItem('permission'))[0];

		this.http.post(`/api/${unitInfo.Company_Code}/products/getmenus`, data)
			.subscribe((response: any) => {
				this.menus = response;
				this.MenuListmyMethodSubject.next(response);
			})
	}

	getMenuList() {
		return this.MenuList;
	}

	UserPermissionSetter() {
		if ("permission" in localStorage) {
			this.Permission = JSON.parse(localStorage.getItem('permission'));
			if(this.Permission.length > 0) {
				this.UserPermissionmyMethodSubject.next(this.Permission);
			}
		}
	}

	getUserPermission() {
		return this.Permission;
	}

	public get isUserLoggedIn(): boolean {
		var status = (localStorage.getItem("id_token") ? true : false);
		return status;
	}

	public get isMRUser(): boolean {
		if ('user' in localStorage) {
		  const user = JSON.parse(localStorage.getItem('user') as any);
		  return user.isMrLogin? true: false;
		}
		return false;
	  }

	GetPageNavigationURL(ParentID) {
		var URL = "";
		let index = this.menus.findIndex(x => x.parent_id == ParentID);
		if (index >= 0) {
			URL = this.menus[index].ROUTER_LINK;
		}
		return URL;
	}

	IsShowPageTiles(ParentID) {
		var IsShow = 0;
		let index = this.menus.findIndex(x => x.parent_id == ParentID);
		if (index >= 0) {
			IsShow = 1;
		}
		return IsShow;
	}

}